import React from "react";

export default function Redirect(props) {
  window.location = props.url
  return <div />
}